import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './style.styl';

const PREFIX_CLASS = 'client-system-status-ui';
const propTypes = {
	className: PropTypes.string,
	imageSrc: PropTypes.string,
	content: PropTypes.node,
	renderImage: PropTypes.func,
};
const defaultProps = {
	className: '',
	imageSrc: '',
	content: '',
	renderImage: null,
};

function ClientSystemStatusUI({
	className,
	imageSrc,
	content,
	renderImage,
}) {
	const hasImage = Boolean(imageSrc) || typeof renderImage === 'function';
	const hasContent = Boolean(content);
	const getVariantClass = () => {
		if (hasImage && hasContent) {
			return `${PREFIX_CLASS}--full-content`;
		}

		if (hasImage) {
			return `${PREFIX_CLASS}--only-image`;
		}

		if (hasContent) {
			return `${PREFIX_CLASS}--only-content`;
		}

		return '';
	};

	return (
		<div className={cx(PREFIX_CLASS, getVariantClass(), className)}>
			<div className={`${PREFIX_CLASS}__container`}>
				{hasImage && (
					<div className={`${PREFIX_CLASS}__image`}>
						{typeof renderImage === 'function' ? renderImage() : <img src={imageSrc} alt="" />}
					</div>
				)}

				{hasContent && (
					<div className={`${PREFIX_CLASS}__content`}>
						{content}
					</div>
				)}
			</div>
		</div>
	);
}

ClientSystemStatusUI.propTypes = propTypes;
ClientSystemStatusUI.defaultProps = defaultProps;

export default memo(ClientSystemStatusUI);
